import moment from "moment";

const getInitialSelectedYear = (data) => {
  const currentYear = new Date().getFullYear();

  return {
    label: data?.requests?.length
      ? moment(data.requests[data.requests.length - 1]?.dateRequested).format(
          "YYYY"
        )
      : currentYear.toString(),
    value: data?.requests?.length
      ? moment(data.requests[data.requests.length - 1]?.dateRequested).format(
          "YYYY"
        )
      : currentYear.toString(),
  };
};

export default getInitialSelectedYear;
